import { CommonDT, DateFilter, PageParams, ResultType, Sorter } from '../../CommonDT';
import { _delete, _get, _post, _put, _req } from '../../request';
import { UserDetailDataType } from '../usr/user-detail-api';
import { UserGroupDataType } from '../usr/user-group-api';
import { UserVipDataType } from '../usr/user-vip-api';
import { VideoListDataType } from '../usr/video-list-api';

export type UserDataType = CommonDT & {
  username: string;
  password: string;
  usersalt?: string;
  loginDateJson?: string;
  loginIpJson?: string;
  loginDays?: number;
  registerIpLan?: string;
  registerIpWan?: string;
  browserFinger?: string;
  browserInfo?: BrowserInfoDT;
  fkUserDetailId?: string;
  overRegister?: number;
};

export type UserBatchDataType = {
  users: UserDataType[];
};

export type UserPageDataType = {
  pageParams: PageParams;
  filter?: UserDataType;
  dateFilter?: DateFilter;
  sorter?: Sorter;
};

export type BrowserInfoDT = {
  fingerprint: string;
  userAgent: string;
  language: string;
  platform: string;
  timeZone: string;
  screenResolution: string;
  colorDepth: number;
};

export type UserPolyInfoDT = {
  asUser: UserDataType;
  asUserDetail: UserDetailDataType;
  vipList: UserVipDataType[];
  videoListDtoList: VideoListDataType[];
};

const get = async (id: string): Promise<ResultType> => {
  return await _get('/sys/user/', id);
};

const list = async (data?: UserDataType): Promise<ResultType> => {
  return await _post('/sys/user/list', data);
};

const page = async (data?: UserPageDataType): Promise<ResultType> => {
  return await _post('/sys/user/page', data);
};

const batchSave = async (data: UserBatchDataType): Promise<ResultType> => {
  return await _post('/sys/user/batchSave', data);
};

const batchUpdate = async (data: UserBatchDataType): Promise<ResultType> => {
  return await _put('/sys/user/batchUpdate', data);
};

const alterStatus = async (userId: string, status: number): Promise<ResultType> => {
  return await _req('/sys/user/alterStatus', 'PUT', { userId, status });
};

const batchRemove = async (ids: string[]): Promise<ResultType> => {
  return await _delete('/sys/user/batchRemove', ids);
};

const getByBrowserFinger = async (data: BrowserInfoDT): Promise<ResultType> => {
  return await _post('/sys/uc/getByBrowserFinger', data);
};

const setUserPassword = async (data: {
  fingerprint: string;
  username: string;
  password: string;
}): Promise<ResultType> => {
  return await _post('/sys/uc/setUserPassword', data);
};

const login = async (data: UserDataType): Promise<ResultType> => {
  return await _post('/sys/uc/login', data);
};

const register = async (data: UserDataType): Promise<ResultType> => {
  return await _post('/sys/uc/register', data);
};

const checkUsername = async (username: string): Promise<ResultType> => {
  return await _get('/sys/uc/checkUsername/', username);
};

const alterPwd = async (data: { userId: string; oldPwd: string; newPwd: string }): Promise<ResultType> => {
  return await _put('/sys/uc/alterPwd', data);
};

const alterEmail = async (data: { userId: string; email: string }): Promise<ResultType> => {
  return await _put('/sys/uc/alterEmail', data);
};

const alterPhone = async (data: { userId: string; phone: string }): Promise<ResultType> => {
  return await _put('/sys/uc/alterPhone', data);
};

const UserApi = {
  get,
  list,
  page,
  batchSave,
  batchUpdate,
  alterStatus,
  batchRemove,
  getByBrowserFinger,
  setUserPassword,
  login,
  register,
  checkUsername,
  alterPwd,
  alterEmail,
  alterPhone,
};

export default UserApi;
